import {
	EWidgets,
	IFormFieldProps
} from "@organisms/ZForm/interface";
import { ClientContact } from "@/Contracts/Clients";

export const getClientContactFormItem = (
	customFieldId: string | null,
	currentActiveClientContact?: ClientContact | null,
	required?: boolean
): IFormFieldProps | null => {
	switch (customFieldId) {
		case "client_user_email":
			return {
				key: "email",
				label: "Email",
				hasFeedback: true,
				required,
				initialValue: currentActiveClientContact?.email || undefined,
				widget: EWidgets.INPUT,
				widgetProps: {
					width: "full",
					type: "email",
					placeholder: "Please enter email",
					"data-testid": "email-input"
				},
				rules: [
					{
						type: "email",
						message: "Please enter valid email"
					}
				]
			};

		case "client_user_phone":
			return {
				key: "phone",
				label: "Phone",
				hasFeedback: true,
				required,
				initialValue: currentActiveClientContact?.phone,
				widget: EWidgets.INPUT,
				widgetProps: {
					width: "full",
					type: "text",
					placeholder: "Please enter phone number",
					"data-testid": "phone-input"
				}
			};
		case "client_user_mobile":
			return {
				key: "mobile",
				label: "Mobile",
				required,
				hasFeedback: true,
				initialValue: currentActiveClientContact?.mobile,
				widget: EWidgets.INPUT,
				widgetProps: {
					width: "full",
					type: "text",
					placeholder: "Please enter mobile number",
					"data-testid": "mobile-input"
				}
			};
		case "client_user_job_title":
			return {
				key: "job_title",
				label: "Job Title",
				hasFeedback: true,
				initialValue: currentActiveClientContact?.job_title,
				widget: EWidgets.INPUT,
				widgetProps: {
					width: "full",
					placeholder: "Please enter job title",
					"data-testid": "job-title-input"
				}
			};
		case "client_user_department":
			return {
				key: "department",
				label: "Department",
				hasFeedback: true,
				initialValue: currentActiveClientContact?.department,
				widget: EWidgets.INPUT,
				widgetProps: {
					width: "full",
					placeholder: "Please enter department",
					"data-testid": "department-input"
				}
			};
		default:
			return null;
	}
};
